import { FC } from 'react';
import styled from 'styled-components';
import { Body2, colors, spacing } from 'ui/theme';
import { BANNER_MANAGEMENT_SETTINGS_ERROR } from 'modules/frequencyManagement/lib/constants';
import { ManageSettingsLink } from 'modules/frequencyManagement/lib/components/summaryBanner/ManageSettingsLink';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${colors.backgroundSecondary};
  border-radius: ${spacing.half};
  border: ${spacing.single} solid ${colors.borderPrimarySubtle};
  padding: ${spacing.plusHalf};
`;

const Body2BoldText = styled(Body2)`
  color: ${colors.textSecondary};
  margin: 0;
`;

export type SummaryBannerProps = {
  messageMedium: SupportedMediums;
};

export const SummaryBannerError: FC<SummaryBannerProps> = ({ messageMedium }) => {
  return (
    <Wrapper>
      <Body2BoldText>{BANNER_MANAGEMENT_SETTINGS_ERROR}</Body2BoldText>
      <ManageSettingsLink messageMedium={messageMedium} />
    </Wrapper>
  );
};
